import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "@/App";
// Tipografías de marca self-hosted. Deben importarse antes de styles.css (que las
// referencia en --font-sans/--font-mono) y funcionan también en el render de PDF.
import "@fontsource/ibm-plex-sans/400.css";
import "@fontsource/ibm-plex-sans/600.css";
import "@fontsource/ibm-plex-sans/700.css";
import "@fontsource/ibm-plex-mono/400.css";
import "@fontsource/ibm-plex-mono/600.css";
import "@/styles.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
